import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { formatPrice } from '../../../helpers'
import StatusBadge from './StatusBadge'

const TransactionCard = ({ trx, onSelectTrx, history }) => {
  const [review, setReview] = useState(trx.review || null)
  const [showReviewModal, setShowReviewModal] = useState(false)
  const [showReviewDetail, setShowReviewDetail] = useState(false)
  const [rating, setRating] = useState(5)
  const [hoverRating, setHoverRating] = useState(0)
  const [comment, setComment] = useState('')

  const formattedDate = new Date(trx.created_at).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })

  const firstProduct = trx.orders && trx.orders.length > 0 ? trx.orders[0] : null
  const remainingCount = (trx.orders?.length || 0) - 1
  const productImage = firstProduct?.product?.image || firstProduct?.image
  const productName = firstProduct?.product?.name || firstProduct?.name || `Produk #${firstProduct?.product_id || firstProduct?.id || 1}`

  const countReview = trx.count_review ?? (trx.orders ? trx.orders.filter(o => o.review != null).length : (trx.review ? 1 : 0))
  const totalOrders = trx.orders?.length || 0

  const handleSaveReview = () => {
    const newReview = {
      rating: rating,
      comment: comment || 'Produk sangat bagus dan sesuai pesanan.'
    }
    setReview(newReview)
    setShowReviewModal(false)
    setShowReviewDetail(true)
  }

  return (
    <div style={{ border: '1px solid rgba(0, 0, 0, 0.08)', borderRadius: '8px', padding: '10px 16px', backgroundColor: '#fff', marginBottom: '8px' }}>
      <div
        onClick={() => onSelectTrx(trx)}
        style={{ cursor: 'pointer' }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <p className="judul" style={{ margin: 0, fontWeight: 'bold', color: '#00a651', textTransform: 'uppercase' }}>
                {trx.code}
              </p>
              <StatusBadge status={trx.status} />
            </div>
            <span style={{ fontSize: '0.85em', color: '#777' }}>
              {formattedDate}
            </span>
          </div>
          <div style={{ textAlign: 'right' }}>
            <p className="harga" style={{ margin: 0, fontSize: '1.1em', fontWeight: '800', color: '#fa591d' }}>
              {formatPrice(trx.total, 'Rp.')}
            </p>
          </div>
        </div>

        {firstProduct && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #f5f5f5' }}>
            {productImage ? (
              <img
                src={process.env.REACT_APP_IMAGE_URL + productImage}
                alt={productName}
                style={{ width: '48px', height: '48px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #eee', flexShrink: 0 }}
              />
            ) : (
              <div style={{ width: '48px', height: '48px', borderRadius: '6px', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: '#aaa', fontSize: '0.75em' }}>
                No Image
              </div>
            )}
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ margin: 0, fontWeight: '600', color: '#333', fontSize: '0.9em', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {productName}
              </p>
              <p style={{ margin: '2px 0 0 0', color: '#777', fontSize: '0.82em' }}>
                {firstProduct.quantity} x {formatPrice(firstProduct.price, 'Rp.')}
              </p>
            </div>
          </div>
        )}

        {remainingCount > 0 && (
          <div style={{ marginTop: '6px', fontSize: '0.85em', color: '#00a651', fontWeight: '700', textAlign: 'right' }}>
            +{remainingCount} Produk lainnya
          </div>
        )}
      </div>

      {/* Section Review Button & Label */}
      {countReview < totalOrders && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #f0f0f0' }}>
          <span style={{ fontSize: '0.85em', color: '#888' }}>
            {countReview === 0 ? 'Belum Review ?' : 'Review Belum Selesai ?'}
          </span>
          <button
            onClick={(e) => {
              e.stopPropagation()
              history.push(`/transaksi/detail/${trx.code}`)
            }}
            style={{
              padding: '4px 12px',
              fontSize: '0.82em',
              background: '#00a651',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 'bold',
              outline: 'none'
            }}
          >
            {countReview === 0 ? 'Buat Review' : 'Lanjut Review'}
          </button>
        </div>
      )}

      {/* Modal Popup Form Review */}
      {showReviewModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
            padding: '20px'
          }}
          onClick={() => setShowReviewModal(false)}
        >
          <div
            style={{
              backgroundColor: '#fff',
              borderRadius: '10px',
              maxWidth: '450px',
              width: '100%',
              padding: '20px',
              boxShadow: '0 5px 20px rgba(0, 0, 0, 0.2)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ margin: '0 0 15px 0', fontSize: '1.1em', fontWeight: 'bold', color: '#00a651' }}>
              Form Review Transaksi ({trx.code})
            </h3>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', fontSize: '0.9em', fontWeight: 'bold', marginBottom: '6px', color: '#444' }}>
                Rating Produk:
              </label>
              <div style={{ display: 'flex', gap: '8px' }}>
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    onClick={() => setRating(star)}
                    onMouseEnter={() => setHoverRating(star)}
                    onMouseLeave={() => setHoverRating(0)}
                    style={{
                      fontSize: '2em',
                      cursor: 'pointer',
                      color: star <= (hoverRating || rating) ? '#ffb400' : '#ddd',
                      transition: 'color 0.15s ease-in-out',
                      userSelect: 'none'
                    }}
                  >
                    ★
                  </span>
                ))}
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '0.9em', fontWeight: 'bold', marginBottom: '6px', color: '#444' }}>
                Ulasan Anda:
              </label>
              <textarea
                rows="4"
                placeholder="Tulis ulasan dan pengalaman Anda membeli produk ini..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  fontSize: '0.9em',
                  resize: 'vertical',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button
                onClick={() => setShowReviewModal(false)}
                style={{
                  padding: '8px 16px',
                  background: '#f5f5f5',
                  color: '#555',
                  border: '1px solid #ccc',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.9em',
                  outline: 'none'
                }}
              >
                Batal
              </button>
              <button
                onClick={handleSaveReview}
                style={{
                  padding: '8px 20px',
                  background: '#00a651',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  fontSize: '0.9em',
                  outline: 'none'
                }}
              >
                Simpan
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default withRouter(TransactionCard)
